import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-assent',
    templateUrl: './assent.component.html',
    styleUrls: ['./assent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssentComponent {

    constructor(
        public dialogRef: MatDialogRef<AssentComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any) {
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
